import React, { FC } from 'react';

import { EXTERNAL_PATHS } from '../../constants';
import s from './CookieContent.module.scss';
import UniversalLink from '../UniversalLink';
import Button from '../Button';
import Icon from '../IconDS22';

export type CookieContentProps = {
  handleClose: () => void;
};

const CookieContent: FC<CookieContentProps> = ({ handleClose }) => (
  <div className={s.root}>
    <div className={s.title}>
      <div className={s.icon}>
        <Icon
          id="cookie"
          size="xl"
        />
      </div>
      <h3 className={s.heading}>
        Cookies & Agreements
      </h3>
    </div>
    <div className={s.content}>
      <div className={s.description}>
        <p className={s.p1}>
          {'By continuing to use this website, you have read and agree to the '}
          <UniversalLink
            to={EXTERNAL_PATHS.TERMS}
            className={s.link}
          >
            Terms of Use
          </UniversalLink>
          {' and agree to the collection and use of your information by cookies and similar technologies, as set forth in our '}
          <UniversalLink
            to={EXTERNAL_PATHS.PRIVACY_POLICY}
            className={s.link}
          >
            Privacy Policy.
          </UniversalLink>
        </p>
      </div>
      <div className={s.button}>
        <Button
          type="button"
          classNameModifier="tertiary noMargin"
          onClick={handleClose}
          fullWidth
        >
          Close
        </Button>
      </div>
    </div>
  </div>
);
export default CookieContent;
